import { useEffect, useState, useRef } from "react";
import SockJS from "sockjs-client";
import { Client } from "@stomp/stompjs";
import Cookies from "js-cookie";

const resolveWebSocketBaseUrl = (origin: string) => {
  const originMappings: Array<[string | undefined, string | undefined]> = [
    [process.env.REACT_APP_URL, process.env.REACT_APP_URL_QA],
    [process.env.REACT_APP_URL_QA, process.env.REACT_APP_URL_QA],
    [process.env.REACT_APP_URL_DEV, process.env.REACT_APP_URL_DEV],
    [process.env.REACT_APP_URL_STAGE, process.env.REACT_APP_URL_STAGE],
    [process.env.REACT_APP_URL_PROD, process.env.REACT_APP_URL_PROD],
  ];

  const mappedUrl = originMappings.find(
    ([mappedOrigin]) => mappedOrigin && origin === mappedOrigin,
  )?.[1];

  return mappedUrl || process.env.REACT_APP_URL_PROD || "";
};

export function useWebSocketNotifications(userId?: number | string) {
  const [notificationCount, setNotificationCount] = useState(0);
  const [forceLogout, setForceLogout] = useState<any>(null);
  const stompClientRef = useRef<Client | null>(null);

  useEffect(() => {
    if (!userId) return;
    const baseURL = `${resolveWebSocketBaseUrl(globalThis.location.origin)}/led`;
    const storedData = Cookies.get("userDetails") || "{}";
    const token = JSON.parse(storedData)?.fetchAPI;
    const client = new Client({
      webSocketFactory: () => new SockJS(`${baseURL}/ws`),
      connectHeaders: {
        Authorization: `Bearer ${token}`,
      },
      reconnectDelay: 5000,
      heartbeatIncoming: 10000,
      heartbeatOutgoing: 10000,
      onConnect: () => {
        client.subscribe(
          `/notifications/notificationCount/${userId}`,
          (msg) => {
            try {
              const data = JSON.parse(msg.body);
              console.log(data, "websocket notification count");
              setNotificationCount(data);
            } catch (err) {
              console.error("Error parsing WebSocket message:", err);
            }
          },
        );

        client.subscribe("/user/notifications/force-logout", (msg) => {
          try {
            const data = JSON.parse(msg.body);
            console.log(data, "force-logout");
            setForceLogout(data?.type);
          } catch (err) {
            console.error("Error parsing WebSocket message:", err);
          }
        });
      },
      onStompError: () => {},
    });

    stompClientRef.current = client;
    client.activate();

    return () => {
      client.deactivate().then(() => {});
    };
  }, [userId]);

  const sendMessage = (destination: string, body: any) => {
    if (stompClientRef?.current?.connected) {
      stompClientRef.current.publish({
        destination,
        body: JSON.stringify(body),
      });
    }
  };

  return { notificationCount, sendMessage, forceLogout };
}
